module.exports = {
      id: "narrated-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#narrated",
      toString: function () {
        return this.url;
      }
    }